<template>
  <div class="content">
    <div class="content-header">
      <div class="content-header__title">Добро пожаловать в личный кабинет «Центра морского права»</div>
      <div class="header__notification">
        <button class="btn_notification" style="display:none;"><i class="far fa-bell"></i></button>
      </div>
    </div>

    <div class="filter">
      <div class="filter-option">
        <RouterLink class="button big light" active-class="active" :to="{name: 'setup'}">Теория</RouterLink>
        <RouterLink class="button big light" active-class="active" :to="{name: 'master-class'}">Мастер-класс</RouterLink>
        <RouterLink class="button big light" active-class="active" :to="{name: 'setup-practice'}">Практика</RouterLink>
        <!-- <RouterLink class="button big light" active-class="active" :to="{name: 'practice-exam'}">Практический экзамен</RouterLink> -->
        <!--        <RouterLink class="button big light" active-class="active" :to="{name: 'practice-iyt'}">Практика IYT</RouterLink>-->
        <RouterLink class="button big light" :to="{name: 'tickets'}">Билеты</RouterLink>
        <RouterLink class="button big light" :to="{name: 'practice-batches'}">Оплаченные пакетные занятия</RouterLink>
        <RouterLink class="button big light" active-class="active" :to="{name: 'general-testing-access'}">Тест ГИМС</RouterLink>
      </div>
    </div>

    <div class="select-city">
      <i class="fas fa-map-marker-alt"></i>
      <div
          class="select-city-item"
          v-for="city in cities"
          :key="city.id"
          @click="city_id = city.id"
          :class="{ 'active': city_id === city.id }"
      >
        {{ city.name }}
      </div>

      <template v-if="0">
        <span class="batch-separator"></span>
        <div class="select-city-item batch" :class="{ 'active': packageBuy }" @click="packageBuy = ~~(!packageBuy);">
          <i class="fas fa-check"></i>
          Пакетный курс
          <span class="select-city-item-question">?</span>
          <span class="select-city-item-answer">Приобретайте необходимое количество занятий и записывайтесь на них в удобное для вас время</span>
        </div>
      </template>
    </div>

    <div class="content-main">
      <div class="item-main">
        <div v-for="category in categories" :key="category.id">
          <h2 class="category-title" v-if="practices.filter(practice => practice.category.id === category.id).length">
            {{ category.title }}
          </h2>
          <p v-if="category.notice">{{ category.notice }}</p>

          <div class="item-main_blocks">
            <CourseOption
                v-for="option in practices.filter(practice => practice.category.id === category.id)"
                :key="option.id"
                :option="option"
                type="checkbox"
                :withoutCheckbox="true"
                :disabled="isDisabled(option.id, option.batches.length)"
                :packages="packageBuy"
                :is-practice="true"
                :full-height="packageBuy && findPracticeId(option.id)"
            >
              <template #default>
                <!--                <input type="checkbox" v-model="practiceIds" :value="option.id">-->
              </template>

              <template #input>
                <select class="select-count" @change="changeCount(option, $event)">
                  <option value="">Выберите количество занятий</option>
                  <option value="one">{{ option.name_one_batch ? option.name_one_batch : '1 занятие' }}</option>
                  <option
                      v-for="batche in option.batches"
                      :disabled="practiceIds.length && !practiceIds.includes(option.id)"
                      :key="batche"
                      :value="batche.count"
                  >
                    {{ batche.name ? batche.name : (batche.count + ' ' + numberDecl(batche.count, ['занятие', 'занятия', 'занятий'])) }}
                  </option>
                </select>

                <div class="package-inline" v-if="0 && packageBuy && findPracticeId(option.id)">
                  <div class="package" v-for="batche in option.batches" :key="batche">
                    <div class="item-main_block_header">
                      <label class="item-main_block__checkbox radio">
                        <input type="radio" v-model="packageCount" name="radio" :value="batche.count">
                        <span class="item-main_block__checkmark"></span>
                      </label>
                      <div class="item-main_block__title">
                        {{ batche.count + ' ' + numberDecl(batche.count, ['занятие', 'занятия', 'занятий']) }}
                      </div>
                    </div>
                    <div>{{ numberFormat(batche.price) }} <CurrencyRuble /></div>
                  </div>
                </div>
              </template>
            </CourseOption>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numberFormat from "@/helpers/numberFormat";
import numberDecl from "@/helpers/numberDecl";
import CourseOption from "@/components/setup/CourseOption";
import CurrencyRuble from "@/components/common/CurrencyRuble";
import { getCities } from "@/data/requests";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

export default {
  components: {
    CourseOption,
    CurrencyRuble
  },
  props: ["data", "modelValue", "package"],

  setup(props, { emit }) {
    const route = useRoute();

    const city_id = ref(1);
    const cities = ref([]);

    // ✅ локальные значения, чтобы UI менялся сразу (а не ждать родителя)
    const packageBuy = ref(props.package?.packageBuy ?? false);
    const packageCount = ref(props.package?.packageCount ?? 0);
    const practiceIds = ref(Array.isArray(props.modelValue?.practiceIds) ? [...props.modelValue.practiceIds] : []);

    // держим синхронизацию, если родитель меняет props
    watch(() => props.package?.packageBuy, (v) => {
      const nv = v ?? false;
      if (packageBuy.value !== nv) packageBuy.value = nv;
    });

    watch(() => props.package?.packageCount, (v) => {
      const nv = v ?? 0;
      if (packageCount.value !== nv) packageCount.value = nv;
    });

    watch(() => props.modelValue?.practiceIds, (ids) => {
      const nv = Array.isArray(ids) ? ids : [];
      // простая проверка "не то же самое"
      if (nv.length !== practiceIds.value.length || nv.some((x, i) => x !== practiceIds.value[i])) {
        practiceIds.value = [...nv];
      }
    }, { deep: true });

    // пушим изменения вверх
    watch(packageBuy, (v) => emit("packageUpdate", v));
    watch(packageCount, (v) => emit("packageCountUpdate", v));

    const setPracticeIds = (ids) => {
      const normalized = (ids || [])
          .map(x => Number(x))
          .filter(x => Number.isFinite(x));

      practiceIds.value = normalized;
      emit("update:modelValue", { practiceIds: normalized });
    };

    const practices = computed(() => {
      return (props.data || []).filter((practice) => practice.city?.id === city_id.value);
    });

    const categories = computed(() => {
      const arrayOfCategories = [];
      (props.data || []).forEach(practice => {
        if (!arrayOfCategories.find(category => practice.category.id === category.id)) {
          arrayOfCategories.push(practice.category);
        }
      });
      return arrayOfCategories.sort((a, b) => a.order - b.order);
    });

    function findPracticeId(id) {
      return practiceIds.value.includes(id);
    }

    function isDisabled(id, batchesCount) {
      return (packageBuy.value && !findPracticeId(id) && practiceIds.value.length > 0) ||
          (packageBuy.value && batchesCount === 0);
    }

    const packageSet = (set, id) => {
      packageBuy.value = set;
      setPracticeIds([id]);        // ✅ важно: не push()
      packageCount.value = 0;
    };

    watch(packageBuy, () => {
      if (!packageBuy.value) {
        setPracticeIds([]);
      }
    });

    onMounted(async () => {
      cities.value = await getCities();
    });

    // ====== обработка ?id=... ======
    const normalizeId = (v) => Array.isArray(v) ? v[0] : v;

    const applyQueryId = () => {
      const q = normalizeId(route.query.id);
      if (!q) return;

      const id = Number(q);
      if (!Number.isFinite(id)) return;

      const practice = (props.data || []).find(p => Number(p.id) === id);
      if (!practice) {
        console.log("Query id:", id, "practice NOT found in props.data yet");
        return;
      }

      if (practice.city?.id) city_id.value = practice.city.id;

      // ✅ сразу отобразится в UI
      setPracticeIds([id]);

      emit('next')

      console.log("Selected by id:", id, "city:", city_id.value, "practiceIds:", practiceIds.value);
    };

    watch([() => route.query.id, () => (props.data || []).length], applyQueryId, { immediate: true });
    // ===============================

    const changeCount = (option, ev) => {
      const value = ev.target.value;

      if (value === "") {
        setPracticeIds(practiceIds.value.filter(id => id !== option.id));
      } else if (value === "one") {
        if (packageBuy.value) {
          packageBuy.value = false;
          packageCount.value = 1;
          setTimeout(() => {
            setPracticeIds([option.id]);
          }, 50);
        } else {
          if (!practiceIds.value.includes(option.id)) {
            setPracticeIds([...practiceIds.value, option.id]);
          }
        }
      } else {
        packageSet(true, option.id);
        packageCount.value = value;
      }
    };

    const isExam = computed(() => route.name === "practice-exam");

    return {
      cities,
      city_id,
      practices,
      categories,
      numberFormat,
      numberDecl,
      practiceIds,
      packageCount,
      packageBuy,
      findPracticeId,
      isDisabled,
      isExam,
      packageSet,
      changeCount
    };
  }
};
</script>

<style lang="scss">
.package-inline {
  display: block;
  .package {
    display: flex;
    color: black;
    font-size: 16px;
    border-radius: 5px;
    line-height: 24px;
    font-weight: 100;
    justify-content: space-between;
    &-minus, &-plus, &-count {
      padding: 5px 10px;
    }
    &-count {
      min-width: 40px;
      max-width: 40px;
      text-align: center;
    }
  }
}
.category-title {
  margin-top: 30px;
}
.batch-separator {
  height: 20px;
  width: 1px;
  background: #a1aeaf;
  margin-right: 10px;
}
.batch-card {
  position: absolute;
  bottom: 40px;
  right: 14px;
  font-size: 14px;
  color: #000;
}
.select-count {
  position: absolute;
  bottom: 60px;
  right: 20px;
  left: 20px;
  height: 30px;
  border: 1px solid #000;
  border-radius: 5px;
}
@media screen and (max-width: 1025px) {
  .select-count {
    bottom: 45px;
  }
  .content-main .item-main .item-main_blocks .item-main_block__desc {
    margin-bottom: 45px;
  }
}
</style>
